import React, { useState } from 'react'
import './Navbar.css'
import {pageInfo} from '../../types/pageInfo';
import { NavLink } from 'react-router';

const Navbar = ({pages}: {pages: pageInfo[]}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className={`Navbar${menuOpen ? ' open' : ''}`}>
      <button className="hamburger" onClick={() => setMenuOpen(prev => !prev)} aria-label="Toggle menu">
        <span />
        <span />
        <span />
      </button>
      <ul className="NavbarLinks">
        {pages.map(page => (
          <li key={page.link}>
            <NavLink
              to={page.link}
              className={({ isActive }) => isActive ? 'NavbarLink active' : 'NavbarLink'}
              onClick={() => setMenuOpen(false)}
            >
              {page.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default Navbar
